import React from "react";
import { useSelector } from "react-redux";
import { Button, Text, Group, Menu } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import tinycolor from "tinycolor2";

import isSpaceThemed from "../../../../utils/IsSpaceThemed";
import isDark from "../../../../utils/IsDarkColor";

const sort = {
  "newest": "Newest",
  "highlighted": "Highlighted",
  "most_liked": "Most Liked",
  "most_commented": "Most Commented"
};

export default function InteractiveSortMenu({ isAdvancedEngagement, sort_by, onChangeSortBy }) {
  const colors = useSelector(state => state.colors);
  const [opened, handlers] = useDisclosure(false);

  const borderColor = isSpaceThemed(colors) ?
    (isDark(colors.background_color)
      ? tinycolor(colors.background_color).lighten(20).toString()
      : tinycolor(colors.background_color).darken(20).toString()
    ) : "#e9ecef";
  
  const textColor = isSpaceThemed(colors) ? colors.default_text_color : "grey";

  return (
    <Group spacing={2}>
      <Menu
        opened={opened}
        onOpen={handlers.open}
        onClose={handlers.close}
        placement="center"
        control={
          <Button
            variant="default"
            size="xs"
            radius="md"
            sx={(theme) => ({
              backgroundColor: "transparent",
              border: `1px solid ${borderColor} !important`,
              "&:hover": {
                backgroundColor: borderColor
              }
            })}
            onClick={() => {
              if (opened) {
                handlers.close();
              } else {
                handlers.open();
              }
            }}
          >
            <Group spacing={2}>
              <Text size="xs" color={textColor} weight={600}>
                {"Sort:"}
              </Text>
              <Text transform="capitalize" size="xs" mx={5} color={textColor} weight={600}>
                {sort[sort_by || "newest"]}
              </Text>
              <FontAwesomeIcon
                size="sm"
                icon={solid("angle-down")}
                color={textColor}
                style={{ position: 'relative', top: 1 }}
              />
            </Group>
          </Button>
        }
      >
        <Menu.Item onClick={() => onChangeSortBy("newest")}>
          {"Newest"}
        </Menu.Item>
        {isAdvancedEngagement && (
          <Menu.Item onClick={() => onChangeSortBy("highlighted")}>
            {"Highlighted"}
          </Menu.Item>
        )}
        <Menu.Item onClick={() => onChangeSortBy("most_liked")}>
          {"Most Liked"}
        </Menu.Item>
        <Menu.Item onClick={() => onChangeSortBy("most_commented")}>
          {"Most Commented"}
        </Menu.Item>
      </Menu>
    </Group>
  );
};